
import { useState } from "react";
import { 
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from "@/components/ui/dialog";
import { CategoryForm } from "@/components/categories/CategoryForm";
import { Category } from "@/lib/types";

interface CategoryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: (category: Category) => void;
}

export function CategoryModal({ open, onOpenChange, onSuccess }: CategoryModalProps) {
  const [loading, setLoading] = useState(false);

  const handleSuccess = (category: Category) => {
    setLoading(false);
    onOpenChange(false);
    if (onSuccess) {
      onSuccess(category);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Create Category</DialogTitle>
          <DialogDescription>
            Add a new category to organize your contracts.
          </DialogDescription>
        </DialogHeader>
        <CategoryForm 
          mode="create" 
          isModal={true} 
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          setLoading={setLoading}
        />
      </DialogContent>
    </Dialog>
  );
}
